import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { WarningFilled } from '@mint-lib/icons';
import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

const ForbiddenErrorPageMobile = () => {
  const { t } = useTranslation('@mint-lib/error-boundary');

  return (
    <div className="mx-auto my-0 flex h-[calc(100vh-80px)] w-full flex-col">
      <div className="flex h-full max-w-76.5 flex-col items-center justify-center self-center">
        <Illustration
          className="size-40"
          component="IllustrationError403Light"
        />
        <div className="inline-flex flex-col justify-center gap-6">
          <div className="inline-flex items-center justify-center gap-2">
            <WarningFilled className="size-5 fill-error-main" />
            <p
              className={typographyVariants({
                variant: 'h3',
                color: 'error',
              })}
            >
              {t('403 Error')}
            </p>
          </div>

          <p
            className={cn(
              'text-center',
              typographyVariants({
                variant: 'h1',
                color: 'primary',
              }),
            )}
          >
            {t('Access Restricted')}
          </p>

          <div
            className={cn(
              'text-left wrap-break-word',
              typographyVariants({
                variant: 'bodyLong01',
                color: 'primary',
              }),
            )}
          >
            <p>{t('Your user lacks the permissions to access this page.')}</p>
            <p>
              {t('Please contact your workspace administrator for assistance.')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ForbiddenErrorPageMobile };
